import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { getTimezones } from "../../services/uidata";
import { filterVisibleTimeZones, isHTML } from "../../utils/helpers";

//css
import "../checkTimeZone/checktimezone.css";
import { updateBannerStaus } from "../../services/admin";

const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
     <style>
        body {
          margin: 0;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
export default function AlertPreviewPopUp(banner_text) {
    //states
    // const navigate = useNavigate();
    const dispatch = useDispatch()
    const { id } = useSelector(
        (state) => state.user.user
    );

    const [newTimezoneData, setnewTimezoneData] = useState([]);
    const [value, setValue] = useState("");
    const [error, setError] = useState(false);


    // const closePopup = () => {
    //     let body = {
    //         user_id: id
    //     }
    //     updateBannerStaus(body).then(() => {
    //         window.loadModal2("#alertPopup", "hide");
    //     }).catch(() => {

    //     })
    // }
    const iframeRef = useRef(null);
    const [iframeHeight, setIframeHeight] = useState("100px");
     useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === "setHeight") {
                let height =  event.data.height + 65;
            setIframeHeight(height + "px");
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
        }, []);

    
   const getInfo = (info) => {

  if (!info) return "";
  console.log(info,"info in get info")

  let rawContentFromDB = info && typeof info === "object" ? info.banner_text : "";

  // If object convert to string
  if (typeof rawContentFromDB !== "string") {
    rawContentFromDB = JSON.stringify(rawContentFromDB);
  }

  let html;

  if (!isHTML(rawContentFromDB)) {
    let text = rawContentFromDB
      .toString()
      .split("\n")
      .map(line => `${line}`)
      .join("");

    return text;
  } else {
    try {
      html = JSON.parse(rawContentFromDB).content;
    } catch {
      html = rawContentFromDB;
    }

    const srcDoc = generateSrcDoc(html);
    return srcDoc;
  }
};
// const getInfo = (info) => {
//   if (!info) return "";

//   let html = "";

//   if (typeof info === "object") {
//     html = info.content || "";
//   } else {
//     html = info;
//   }

//   return generateSrcDoc(html);
// };
return (
        <div
            className="modal fade mt-5 "
            id="alertPreviewPopUp"
            data-backdrop="static"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-alert-box modal-xl">
                <div className="modal-content">
                    <div className="modal-body mb-4">
                        <div className="schedule-popup">
                            <div className="d-flex align-items-center justify-content-between">

                                <span className="d-flex align-items-center margin-unset">
                                    <img className='w-50-px' src="./images/heart.png" />
                                    <span className="font-size-28 ml-1 ">Info</span>

                                </span>
                                <span className="pointer align-self-baseline" onClick={() => window.loadModal2("#alertPreviewPopUp", "hide")}>

                                    X
                                </span>
                            </div>


                            {/* <h3 className="text-center ">
                                <img className='w-70-px' src="./images/error-mark.png" />
                            </h3> */}
                            <div className="mb-2 mt-2">
                                <div className="cuntrey-website p-2 line-height-30px">
                                    {}
                                    <iframe 
                                        ref={iframeRef}
                                        srcDoc={getInfo(banner_text)}
                                        style={{ width: "100%",height: iframeHeight, border: "unset" }}
                                        title="Editor Preview"
                                        />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
